import styled from 'styled-components';

export const Content = styled.div`
  border: 1px solid #f4f4f4;
  border-radius: 6px;
  padding: 21px;
  .agenda-title {
    padding-top: 29px;
    margin-top: 17px;
    border-top: 1px solid #dedfeb;
  }
  .agenda-calendar-header {
    height: 40px;
  }
  .agenda-calendar-title {
    margin: 0;
    font-size: 14px;
    color: #0b1a30;
  }
  .fc-timegrid-slot {
    height: 32px;
  }
  .fc-col-header {
    display: none;
  }
  .fc-day-today {
    background-color: transparent !important;
    .fc-col-header-cell-cushion {
      color: #2552f3 !important; // TODO: theme
    }
  }
  .fc-scrollgrid {
    border: none;
  }
  .fc-scrollgrid-section-body > td {
    border: none !important;
  }
  .fc-timegrid-slot-label-cushion {
    font-size: 12px;
    color: #6b7083;
    font-weight: 400;
  }
  .agenda-event-item {
    border: none;
    background-color: #f4f4f4;
    border-radius: 2px;
    border-left: 4px solid #dbdde2;
    div {
      font-size: 12px;
      color: #0b1a30;
      font-weight: 500;
    }
    .fc-event-main-frame {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 8px;
    }
    .fc-event-title-container {
      flex: none;
    }
  }
`;
